import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'were_interpreters_present_during_verification_assessment'

export const dataPointDefinition = {
  retracedId: 'were_interpreters_present_during_verification_assessment',
  name: 'Were any interpreters present during verification/assessment?',
  description:
    'If yes, please provide detailed information in the question below about parties involved in verification/assessment activity. ',
  meta: {
    slcpMeta: {
      key: 'vd-ver-1',
      number: 'VD-VERI-11',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'yes-no',
      versionImported: '1.7.0',
      verificationTypeReq: '',
      verificationSelectionOptList: '',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '',
      machineShowHide: '',
      completionCondition: '',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'yes_no',
      name: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['yes_no'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'vd-ver-1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34700,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
